import { Flex, Icon, Input } from '@chakra-ui/react';
import { RiSearchLine } from 'react-icons/ri';
import { search } from 'ss-search';

import { TituloDTO } from '../../../dtos/TituloDTO';
import useDebounce from '../../../utils/useDebounce';

type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
}

interface DTSearchParams {
	titulos: TituloDTO[];
	setPesqTitulos: (titulo: TituloDTO[]) => void;
  controls: ControlsData;
  setControls: (control: ControlsData) => void;
  handleUpdateList: (
    page: number,
    perPage: number,
		titulos: TituloDTO[],
  ) => void;
};

const searchKeys = [
	'parcela',
	'data',
	'data_baixa',
	'vencimento',
	'nome',
	'name_pay',
	'vlr_cred',
	'vlr_deb',
	'saldo_cred',
	'saldo_deb',
	'pago',
	'amortizado',
	'multa',
	'juros',
	'id_emp'
];

const DTSearch: React.FC<DTSearchParams> = ({
	titulos,
	setPesqTitulos,
  controls,
  setControls,
  handleUpdateList,
}) => {
	
  function handlePesquisa(event: string) {
    const texto = event;

    if (texto === '' || texto === ' ') {
			setPesqTitulos(titulos);

      setControls({
        ...controls,
        page: 1,
				totalPage: Math.ceil(titulos.length / controls.perPage),
      });
			
			handleUpdateList(1, controls.perPage, titulos);
      return;
    }
		
		const results = search(titulos, searchKeys, texto) as TituloDTO[];

		setPesqTitulos(results);

    setControls({
      ...controls,
      page: 1,
      totalPage: Math.ceil(results.length / controls.perPage),
    });

    handleUpdateList(1, controls.perPage, results);
  }

	const debounceChange = useDebounce(handlePesquisa, 800);

  return (
		<Flex w="100%" as="form" ml={["0", "0", "4"]} mb={2}>
      <Flex
        as="label"
        flex="1"
        py="2"
        pl="2"
        pr="6"
        maxWidth={400}
        alignSelf="center"
        color="gray.900"
        position="relative"
        bg="gray.50"
        borderRadius="full"
      >
        <Input
          color="gray.900"
          variant="unstyled"
          px="4"
          mr="4"
          placeholder="Pesquisar"
          _placeholder={{ color: 'gray.400' }}
					onChange={e => debounceChange(e.target.value)}
        />

        <Icon as={RiSearchLine} fontSize="20" color="blue.500" />
      </Flex>
    </Flex>
  );
};

export default DTSearch;
